import { SelectionColumn, SelectionItem } from "./SelectionColumn";

export interface SectionColumnProps {
  sections: SelectionItem[];
  selectedSections: string[];
  onSectionChange: (value: string) => void;
  allowMultipleSelection?: boolean;
  customWidth?: string;
}

export const SectionColumn = ({
  sections,
  selectedSections,
  onSectionChange,
  allowMultipleSelection = false,
  customWidth,
}: SectionColumnProps) => {
  return (
    <SelectionColumn
      title="Section"
      data={sections}
      selectedItems={selectedSections}
      onSelectionChange={onSectionChange}
      valueField="Value"
      titleField="Title"
      layoutMode="dynamic"
      isNarrowColumn={false}
      showTitleDivider={false}
      allowMultipleSelection={allowMultipleSelection}
      customWidth={customWidth}
    />
  );
};
